import Styles from './OutlineLoadingState.module.scss'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'

export const OutlineLoadingState = () => (
  <div className={Styles.stub}>
    <LineSkeleton className={Styles.h2Shimmer} />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />
    <LineSkeleton className={Styles.h3Shimmer} width="60%" />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />

    <LineSkeleton className={Styles.h2Shimmer} />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />
    <LineSkeleton className={Styles.h3Shimmer} width="60%" />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />

    <LineSkeleton className={Styles.h2Shimmer} />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />
    <LineSkeleton className={Styles.h3Shimmer} width="60%" />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />

    <LineSkeleton className={Styles.h2Shimmer} />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />
    <LineSkeleton className={Styles.h3Shimmer} width="60%" />
    <LineSkeleton className={Styles.h3Shimmer} width="75%" />
  </div>
)
